import React from 'react';
import { SvgProps } from 'models/svg';

const ArrowDown = ({ className }: SvgProps) => {
  return (
    <svg className={className} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.5' y='0.5' width='23' height='23' rx='11.5' stroke='#E5E7EB' />
      <path
        d='M11.4609 18.2891L7.71094 14.5391C7.42969 14.2344 7.42969 13.7656 7.71094 13.4609C8.01562 13.1797 8.48438 13.1797 8.78906 13.4609L11.25 15.9453V7.25C11.25 6.82812 11.5781 6.5 12 6.5C12.4219 6.5 12.75 6.82812 12.75 7.25V15.9453L15.2109 13.4609C15.5156 13.1797 15.9844 13.1797 16.2891 13.4609C16.5703 13.7656 16.5703 14.2344 16.2891 14.5391L12.5391 18.2891C12.2344 18.5703 11.7656 18.5703 11.4609 18.2891Z'
        fill='#222156'
      />
    </svg>
  );
};

export default ArrowDown;
